import { render, staticRenderFns } from "./WebpartManageTestView.vue?vue&type=template&id=59cfb69a"
import script from "./WebpartManageTestView.vue?vue&type=script&lang=ts"
export * from "./WebpartManageTestView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports